import { Navigate, useParams } from "react-router-dom";

/**
 * Legacy event-settings bookmarks (`/settings/collaboration`, `/my-access`,
 * `/role-templates`, `/api-tokens`). A relative `<Navigate to="../access">`
 * resolves against the ROUTE hierarchy (these are flat absolute routes under
 * a pathless layout), so ".." landed on the literal `/access` 404 — the
 * absolute target is built from the eventId param instead (H20). `tab` is the
 * access tab the old page became (members wave U3: roles, tokens; none =
 * Members); a viewer that tab is not offered to lands on Members there.
 */
export function EventSettingsAccessRedirect({ tab = "" }: { tab?: "" | "roles" | "tokens" }) {
  const { eventId = "" } = useParams<{ eventId: string }>();
  return <Navigate to={`/event/${eventId}/settings/access${tab ? `/${tab}` : ""}`} replace />;
}
